import { create } from 'zustand';

interface SoftKeyboardHeightState {
	softKeyboardHeight: number;
	setSoftKeyboardHeight: (newHeight: number) => void;
}

const useSoftKeyboardHeightStore = create<SoftKeyboardHeightState>((set) => ({
	softKeyboardHeight: 0,
	setSoftKeyboardHeight: (newHeight: number) => {
		set({ softKeyboardHeight: newHeight });
	}
}));

export default useSoftKeyboardHeightStore;
